import { render, staticRenderFns } from "./subject.vue?vue&type=template&id=b72a42c2"
import script from "./subject.vue?vue&type=script&lang=js"
export * from "./subject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports